export default {
  en: {
    org: {
      managed: {
        title: 'RL managed',
        description: 'This profile has been created and is managed by Risk Ledger.',
      },
      trialRestricted: 'Trial restricted',
      trialRestrictedDescription: 'This profile is not included in your trial.',
      unclaimed: 'Unclaimed',
      previewCta: 'Preview',
    },
    quickConnect: {
      browseSuppliers: 'Browse all suppliers',
      error: 'Supplier profiles could not be loaded.',
      trial: {
        availableTitle: 'Trial suppliers',
        availableSubtitle: 'Suppliers you can connect with during your Risk Ledger trial.',
        unavailableTitle: 'Other suppliers',
        unavailableSubtitle: 'Suppliers on the Risk Ledger network available after your trial.',
      },
    },
    entityName: 'Supplier',
    filterAttributes: {
      searchPlaceholder: 'Search suppliers...',
      name: 'Name',
      website: 'Website',
      country: 'Country',
      sectorID: 'Sector',
    },
    noResultsTitle: 'No suppliers found',
    noResultsSubtitle: "We couldn't find a supplier that matched your search.",
    sort: {
      title: 'Sort by:',
      date: 'Joined date',
      alphabetical: 'Alphabetical',
      popularity: 'Popularity',
    },
  },
};
